import React from 'react';
import { getVolunteerTimePillDisplay, getShiftPublicDescription } from '../utils/volunteerShifts';
import './VolunteerSignup.css';

export function volunteerTimeLineLabel(shift) {
  const d = getVolunteerTimePillDisplay(shift);
  if (d.variant === 'allday') return 'All day';
  if (d.variant === 'range') return d.text;
  return d.text;
}

function SpotDots({ needed, claimed, allGray }) {
  const n = Math.max(0, Number(needed) || 0);
  const c = Math.min(n, Math.max(0, Number(claimed) || 0));
  const chars = [];
  for (let i = 0; i < n; i += 1) {
    const gray = allGray || i < c;
    chars.push(
      <span key={i} className={gray ? 'volunteer-page__dot volunteer-page__dot--claimed' : 'volunteer-page__dot volunteer-page__dot--open'}>
        ●
      </span>,
    );
  }
  return <span className="volunteer-page__dots">{chars}</span>;
}

export function ShiftTaskCard({ shift, mine, full, openSpots, busy, onClaim, onRelease }) {
  const desc = getShiftPublicDescription(shift);
  const need = Number(shift?.needed) || 0;
  const claimed = Array.isArray(shift?.assignees) ? shift.assignees.length : 0;

  if (mine) {
    return (
      <article className="volunteer-page__card volunteer-page__card--mine">
        <div className="volunteer-page__card-left">
          <div className="volunteer-page__mine-head">
            <span className="volunteer-page__mine-check" aria-hidden="true">
              ✓
            </span>
            <span className="volunteer-page__task-name">{(shift.role || '').toString()}</span>
          </div>
          {desc ? <p className="volunteer-page__task-desc volunteer-page__task-desc--mine">{desc}</p> : null}
        </div>
        <button type="button" className="volunteer-page__release" disabled={busy} onClick={() => onRelease(shift)}>
          Release
        </button>
      </article>
    );
  }

  if (full) {
    return (
      <article className="volunteer-page__card volunteer-page__card--full">
        <div className="volunteer-page__card-left volunteer-page__card-left--full">
          <div className="volunteer-page__task-name volunteer-page__task-name--muted">{(shift.role || '').toString()}</div>
          {desc ? <p className="volunteer-page__task-desc volunteer-page__task-desc--full">{desc}</p> : null}
          <div className="volunteer-page__spots-row">
            <SpotDots needed={need} claimed={claimed} allGray />
          </div>
        </div>
        <span className="volunteer-page__full-badge" aria-label="This shift is full">
          Full
        </span>
      </article>
    );
  }

  return (
    <article className="volunteer-page__card volunteer-page__card--avail">
      <div className="volunteer-page__card-left">
        <div className="volunteer-page__task-name">{(shift.role || '').toString()}</div>
        {desc ? <p className="volunteer-page__task-desc">{desc}</p> : null}
        <div className="volunteer-page__spots-row">
          <SpotDots needed={need} claimed={claimed} allGray={false} />
          <span className="volunteer-page__spots-label">
            {openSpots === 1 ? '1 spot open' : `${openSpots} spots open`}
          </span>
        </div>
      </div>
      <button type="button" className="volunteer-page__signup" disabled={busy} onClick={() => onClaim(shift)}>
        Sign up
      </button>
    </article>
  );
}
